import { getColors } from "../../../jss_setup/colors";

export const SearchButton = {
  borderRadius: "0px",
  background: getColors().secondary_color,
  border: `2px solid ${getColors().secondary_color}!important`,
  "&:hover": {
    background: "white",
    color: getColors().secondary_color,
  },
};

export const RegularButton = {
  borderRadius: "0px",
};
